import styled, { css } from "styled-components";
import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Popover from "components/common/Popover";
import { ColorPicker } from "components/common";
import { colors as defaultColors } from "views/components/visualizations/Colors";
export const ColorHintWrapper = styled.div`
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const ColorHint = styled.div(
  ({ color, theme }) => css`
    cursor: pointer;
    background-color: ${color};
    width: ${theme.spacings.md};
    height: ${theme.spacings.md};
  `
);
const ColorConfigurationPopover = ({ onColorSelect, curColor, title }) => {
  const { t } = useTranslation("aggregation");
  const [showPopover, setShowPopover] = useState(false);
  const togglePopover = useCallback(() => setShowPopover((show) => !show), []);
  const _onColorSelect = useCallback(
    (color) => {
      onColorSelect(color);
      togglePopover();
    },
    [onColorSelect, togglePopover]
  );
  return /* @__PURE__ */ React.createElement(Popover, { position: "top", withArrow: true, opened: showPopover }, /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement(ColorHintWrapper, null, /* @__PURE__ */ React.createElement(ColorHint, { "aria-label": t("wizard_common.color_hint"), onClick: togglePopover, color: curColor }))), /* @__PURE__ */ React.createElement(Popover.Dropdown, { title }, /* @__PURE__ */ React.createElement(ColorPicker, { color: curColor, colors: defaultColors, onChange: _onColorSelect })));
};
export default ColorConfigurationPopover;
